var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsageTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.614,
    height: 13.673,
    viewBox: "0 0 13.614 13.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1799",
    "data-name": "Path 1799",
    transform: "translate(-6504.408 -748.037)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6504.408,761.71v-8.428l6.66-5.245,6.954,5.245v8.428Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6517.271484375 760.9597778320312 L 6517.271484375 753.6558837890625 L 6511.0771484375 748.9837646484375 L 6505.15771484375 753.6461181640625 L 6505.15771484375 760.9597778320312 L 6517.271484375 760.9597778320312 M 6518.021484375 761.7097778320312 L 6504.40771484375 761.7097778320312 L 6504.40771484375 753.2821655273438 L 6511.0673828125 748.036865234375 L 6518.021484375 753.2821655273438 L 6518.021484375 761.7097778320312 Z",
    stroke: "none",
    fill: "#29a19c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    transform: "translate(5.076 8.452)",
    fill: "#fff",
    stroke: "#29a19c",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.581,
    height: 5.209,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 2.831,
    height: 4.459,
    rx: 0.625,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageTypeIcon);
export default __webpack_public_path__ + "static/media/UsageTypeIcon.ad26237d6e8698517e82aa282efee861.svg";
export { ForwardRef as ReactComponent };